/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { InputHTMLAttributes } from 'react';
import styled from '@emotion/styled';
import ThemeTypes from 'common/types/ThemeTypes';
import { useTheme } from '@emotion/react';
import { ReactComponent as LockIcon } from 'common/icons/lock.svg';
const InputField = styled.input`
    outline: none;
    border: none;
    border: 1px solid ${(props:InputFieldProps) => props.error ? props.theme.colors.error + '!important' : props.theme.colors.gray};
    border-radius: 8px;
    background-color: ${(props) => props.theme.colors.secondaryColor};
    font-family: Mulish;
    font-size: 16px;
    position: relative;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
    letter-spacing: 1px;
    color: ${(props) => props.theme.colors.primaryTextColor};
    height: 36px;
    padding: 10px 16px;
    transition: border-color 0.2s ease-in-out;
    &::placeholder {
        color: ${(props) => props.theme.colors.gray};
    }
    &:focus {
        border-color: ${(props) => props.theme.colors.primaryColor};
    }
    &:disabled {
      color: ${(props) => props.theme.colors.gray};
      cursor: default;
    }
`;

const InputWrapper = styled.div`
  display:flex;
  flex-direction: column;
  position:relative;
  width: 100%;
`;

const IconWrapper = styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  display:flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  transform: translateY(-50%);
`;

type InputProps = {
  placeholder?: string,
  value: string,
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
  props?: InputHTMLAttributes<HTMLInputElement>,
  error?: boolean | string,
  className?: string,
  name?: string,
  disabled?: boolean,
};

type InputFieldProps = {
  error: boolean | string,
  disabled?: boolean,
  theme: ThemeTypes,
} & InputHTMLAttributes<HTMLInputElement>;

export default function Input({ placeholder, onChange, value, props, error, className, name, disabled }:InputProps): JSX.Element {
  const theme = useTheme();
  return (
    <InputWrapper className={className}>
      <InputField disabled={disabled} theme={theme} name={name} error={error} value={value} onChange={onChange}  placeholder={placeholder} {...props} />
      {disabled && <IconWrapper>
        <LockIcon />
      </IconWrapper>}
    </InputWrapper>
  );
}

